import React from "react"
import {  useTranslation } from "react-i18next";
import FormSelect from "../shared/formElements/FormSelect";

const AddressList = ({upgrade, addressList}) => {
    const { t } = useTranslation(["translation"]);

    return(
        <>
            { !upgrade && addressList?.length > 0 &&  <FormSelect
                webClassName="form-floating"
                bsClassName="col-md-12"
                label={t("FORM_CONTENT.FORM_LABEL.ADDRESSESS")}
                name="addressess"
                id="addressess"
                required={ false}
                errorMsg={t("FORM_CONTENT.FORM_ERROR.ADDRESSESS")}
                minLength={1}
                maxLength={100}
                optionData={addressList}
                placeholder={t("FORM_CONTENT.FORM_PLACEHOLDER.ADDRESSESS")}
                showSelectDefault={true}
            /> }
        </>
    )
}

export default AddressList;